import { get, post, patch } from "./api";

// Uncategorized Transactions API
export const getUncategorizedTransactions = (customerId, params = {}) => {
  return get(`/api/v2/customers/${customerId}/uncategorized/transactions/`, params);
};

export const getUncategorizedTransaction = (customerId, transactionId) => {
  return get(`/api/v2/customers/${customerId}/uncategorized/transactions/${transactionId}/`);
};

export const resolveUncategorizedTransaction = (customerId, transactionId) => {
  return post(`/api/v2/customers/${customerId}/uncategorized/transactions/${transactionId}/resolve/`);
};

export const updateUncategorizedTransaction = (customerId, transactionId, data) => {
  return patch(`/api/v2/customers/${customerId}/uncategorized/transactions/${transactionId}/`, data);
};

// Uncategorized Disruptions API
export const getUncategorizedDisruptions = (customerId, params = {}) => {
  return get(`/api/v2/customers/${customerId}/uncategorized/disruptions/`, params);
};

export const getUncategorizedDisruption = (customerId, disruptionId) => {
  return get(`/api/v2/customers/${customerId}/uncategorized/disruptions/${disruptionId}/`);
};

export const resolveUncategorizedDisruption = (customerId, disruptionId) => {
  return post(`/api/v2/customers/${customerId}/uncategorized/disruptions/${disruptionId}/resolve/`);
};

export const cancelUncategorizedDisruption = (customerId, disruptionId) => {
  return post(`/api/v2/customers/${customerId}/uncategorized/disruptions/${disruptionId}/cancel/`);
};

// Check for active disruptions (for banner)
export const checkActiveDisruptions = (customerId) => {
  return get(`/api/v2/customers/${customerId}/uncategorized/disruptions/`, { status: 'active' });
};

// Detection and Summary API
export const detectUncategorizedTransactions = (customerId) => {
  return post(`/api/v2/customers/${customerId}/uncategorized/transactions/detect/`);
};

export const getUncategorizedSummary = (customerId) => {
  return get(`/api/v2/customers/${customerId}/uncategorized/transactions/summary/`);
};

// Business Logic API
export const validateUncategorizedResolution = (customerId) => {
  return get(`/api/v2/customers/${customerId}/uncategorized/transactions/validate/`);
}; 